import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import useChatConversationTranscript from "shared/ChatConversation/useChatConversationTranscript";
import { downloadFile } from "utils/file";

const useAssistantPanelChatDownloadTranscript = (chatId: string | undefined) => {
  const { reportError, onError } = useTypedContext(FlashContext);
  const { loadTranscript, loading } = useChatConversationTranscript();

  const downloadTranscript = useCallback(() => {
    if (!chatId) {
      return;
    }

    loadTranscript(chatId).then((transcript) => {
      if (transcript === undefined) {
        reportError({ message: "Could not download the chat" });
        return;
      }

      downloadFile(`spacelift-chat-${chatId}.md`, transcript);
    }, onError);
  }, [chatId, loadTranscript, reportError, onError]);

  return { downloadTranscript, loading };
};

export default useAssistantPanelChatDownloadTranscript;
